import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getSimilarCreators({ payload: { id, signal, handledErrors, suppressCriticalErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.creator_object.similar_creators,
      id,
      signal
    });

    yield put(actions.getSimilarCreatorsDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSimilarCreatorsFailed,
      handledErrors,
      suppressCriticalErrors,
      endpoint: api.creator_object.similar_creators.url
    });
  }
}

export const getSimilarCreatorsSaga = takeEvery(types.GET_SIMILAR_CREATORS_REQUEST, getSimilarCreators);